import { createEventEnvelope } from '../events/envelope';
import { normalizeEventName } from '@trafilea/tss-lib-funnel-schema-ts';
import type { ActionHandler } from './types';

/** Loop guard: a dispatch chain deeper than this is dropped (H5). */
export const MAX_EVENT_HOPS = 3;

export const dispatchEventHandler: ActionHandler = {
  type: 'dispatch_event',
  execute(ctx) {
    const rawName = ctx.config.event_name ? String(ctx.config.event_name) : ctx.action.label;
    if (!rawName) return;
    // D-G: emit the plain behavioral name on the bus; transport applies the wire
    // prefix. Compatible ui.* / funnel.ui.* authored names normalize here.
    const name = normalizeEventName(rawName);
    const nextHop = (ctx.hopCount ?? 0) + 1;

    if (nextHop > MAX_EVENT_HOPS) {
      ctx.logger.warn('dispatch_event dropped: event hop limit exceeded (loop guard)', {
        eventName: name,
        stepId: ctx.stepId,
        hopCount: nextHop,
      });
      return;
    }

    if (ctx.featureEnabled()) {
      ctx.eventBus.emit(
        createEventEnvelope(
          name,
          'storefront-funnel',
          {
            params: { ...(ctx.config as Record<string, unknown>) },
            context: { stepId: ctx.stepId, trigger: 'dispatch_event' },
          },
          {
            correlationId: ctx.sessionId,
            scope: { tenantId: ctx.tenantId },
            hopCount: nextHop,
          },
        ),
      );
    } else {
      window.dispatchEvent(new CustomEvent(rawName, { detail: ctx.config }));
    }
  },
};
